function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "asana_a",
  cx: "50.014%",
  cy: "54.715%",
  r: "71.729%",
  fx: "50.014%",
  fy: "54.715%",
  gradientTransform: "matrix(.92431 0 0 1 .038 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFB900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "60%",
  stopColor: "#F95D8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.9%",
  stopColor: "#F95353"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#asana_a)",
  d: "M62.56 39.101c-9.6 0-17.38 7.78-17.38 17.378 0 9.598 7.78 17.38 17.38 17.38 9.597 0 17.377-7.782 17.377-17.38 0-9.598-7.78-17.378-17.378-17.378zm-45.151.001C7.81 39.102.03 46.882.03 56.479c0 9.598 7.78 17.379 17.378 17.379 9.598 0 17.379-7.781 17.379-17.379 0-9.598-7.781-17.377-17.38-17.377zm39.953-21.724c0 9.598-7.78 17.38-17.377 17.38-9.6 0-17.38-7.782-17.38-17.38C22.605 7.781 30.385 0 39.985 0 49.582 0 57.36 7.78 57.36 17.378h.001z",
  transform: "translate(0 3)"
});

var SvgAsanaIco = function SvgAsanaIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAsanaIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/asana_ico.4da93b60.svg";
export { ForwardRef as ReactComponent };